import { config, handleResponse } from '../../_helpers';

export const DBService = {
    getAllDB,
};


function getAllDB() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Dbconstants`, requestOptions).then(handleResponse);
}
